import React, { Component } from 'react';
import Modal from "../../../../../shared/modal";
import TableAccesory from './table-accessory';
import Approve from './form-approve';
import Reject from './form-reject';
import { STATUS_SERVICE } from '../../../../../../constants/app/services';

const ModalResolve = ({ inspection, open = false, isApproved, handleSelect, handleClose, handleApprove, status, handleChangeRejected, handleReject, handlePresencial}) => {

	return(
		<Modal open={open}>
			<div className="col-xs-6 col-sm-6 col-md-6 inspection">
				<span className="h2 m20 ml10 mb10">Resolver inspección</span>
				<span className="text-sm ml10">RESOLUCIÓN FINAL</span>
				<div className="btn-switch ml10 mt10" >
					<input type="checkbox" checked={isApproved}/>
					<span className="slider" />
					<div className="buttons">
						<div role="button" tabIndex="0" onClick={handleSelect(true)}>
							<span className="icon-accept icon-24" />
							Aprobar
						</div>				
							<div role="button" tabIndex="0" onClick={handleSelect(false)}>
								<span className={(inspection.state && inspection.state.inspectionStatus === 'SENT') ? 'icon-state-returned icon-24' : 'icon-state-reject icon-24' }/>
								{(inspection.state && inspection.state.inspectionStatus === 'SENT') ? 'Presencial' : 'Rechazar'}
							</div>
					</div>
				</div>
				{ (isApproved) ? <Approve handleClose={handleClose}/> : <Reject handleChangeRejected={handleChangeRejected} state={inspection.state && inspection.state.inspectionStatus} />}
				<div className="row">
						<button type="button" className="btn btn-primary mr10 col-xs-5 col-md-5" disabled={(status.approved === STATUS_SERVICE.INPROGRESS)} onClick={(inspection.state && inspection.state.inspectionStatus === 'SENT' && !isApproved) ? handlePresencial : (isApproved) ? handleApprove : handleReject}>Confirmar</button>
						<button type="button" className="btn btn-outline-secondary col-xs-5 col-md-5" onClick={handleClose}>Cancelar</button>
				</div>
			</div>
			<div className="col-xs-6 col-sm-6 col-md-6 endoso" style={{overflow: 'auto'}}>
				<span className="h2 m20 ml10 mb10">MODIFICACIÓN EN EL ENDOSO</span>
				<span className="text-md--light ml10">Accesorios adicionales</span>
				<div className="ml10">
					<TableAccesory accessories={inspection.accessories} />
				</div>
				<br/>
				<span className="text-md--light ml10">Daños</span>
				<span className="text-md ml10">{inspection.damageComment || 'No presenta daños'}</span>
			</div>
		</Modal>
	);
}
export default ModalResolve;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/resolve/modal-resolve.js